import React from "react";
import "react-tabs/style/react-tabs.css";
import { Form } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Col } from "reactstrap"; //CardImg,
import { Breadcrumb } from "react-bootstrap";
import MUIDataTable from "mui-datatables";
import { connect } from "react-redux";
import {Helmet} from "react-helmet";

class DemoTankFlowView extends React.Component {
  state = {};
  constructor(props) {
    super(props);
		this.state = {
		  tabs: ["", "", ""],
		  tabPanel: ["", "", ""],
		  tabPanel0: "",
		  tabPanel1: "",
		  tabPanel2: "",
		  modal: false,
		  tankData: [],
		  iotHistoryData: [],
		  flowmeterdata: [],
		  iotlevelData: [],
		  test: [],
		  deviceId: "",
		  capacity: "",
		  type: "",
		  shape: "",
		  height: "",
		  length: "",
		  width: "",
		};
  }

  nextPath(path, value) {
    this.props.history.push({ pathname: path, data: value, state: { data: value } });
  }

  componentDidMount() { }


  render() {

	const mystyle = {
	  marginRight: "5px"
    };
	const leveldev = {
	    backgroundColor: "white",
		padding: "10px"
	};
	const leveldevheadercolor = {
	    color: "red"
	};
	
	const wrapper = {
		backgroundColor: "#2d4e5a",
		height: "200px",
		width: "200px",
		position: "relative"
	}

    const columns = [
      {
        name: "id",
        label: "Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "flow_device_id",
        label: "Flow Meter Id",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "StartDateTime",
        label: "Delivery Start At",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "EndDateTime",
        label: "Delivery End At",
        options: {
          filter: true,
          sort: true,
        }
      },
	  {
        name: "totalKL",
        label: "Total KL",
        options: {
          filter: true,
          sort: true,
        }
      }
    ];


    const options = {
       filterType: "textField",
      fixedHeader: true,
      sort: true,
      search: true,
      selectableRows: false,
      responsive: "scroll",
      rowsPerPage: 15,
      rowHove: true,
      selectableRowsHeader: true,
      expandableRows: false,
      expandableRowsOnClick: false,
      downloadOptions: {
        filename: 'flowmeter.csv',
      },
    };

   
	let dataArr1 = [			
		['3',"SIPL_PRIDE_2020_0006","2020-11-06T21:39:24.543","2020-11-06T22:21:49.413","22.5"],
		['3',"SIPL_PRIDE_2020_0006","2020-11-06T18:09:04.79","2020-11-06T18:50:40.767","22.4"],
		['3',"SIPL_PRIDE_2020_0006","2020-11-06T01:34:24.13","2020-11-06T02:19:38.097","22.8"],
		['3',"SIPL_PRIDE_2020_0006","2020-11-05T23:18:20.19","2020-11-06T00:23:02.247","27.5"],
		['3',"SIPL_PRIDE_2020_0006","2020-11-05T22:19:40.993","2020-11-05T23:07:41.073","22.1"],
		['3',"SIPL_PRIDE_2020_0006","2020-11-05T17:21:13.023","2020-11-05T18:05:12.54","22.4"],
		['3',"SIPL_PRIDE_2020_0006","2020-11-04T16:57:54.543","2020-11-04T17:45:45.947","22.3"],
		['3',"SIPL_PRIDE_2020_0006","2020-11-04T15:49:17.647","2020-11-04T16:45:54.47","27.2"],
		['3',"SIPL_PRIDE_2020_0006","2020-11-04T11:28:37.48","2020-11-04T12:11:18.94","22.2"],
		['3',"SIPL_PRIDE_2020_0006","2020-11-04T07:25:17.333","2020-11-04T08:07:14.953","22.8"],
		['3',"SIPL_PRIDE_2020_0006","2020-11-02T11:25:20.807","2020-11-02T12:50:10.177","23.4"],
		['3',"SIPL_PRIDE_2020_0006","2020-10-30T21:39:45.823","2020-10-30T22:29:39.737","22.4"],
		['3',"SIPL_PRIDE_2020_0006","2020-10-29T16:17:21.597","2020-10-29T17:17:15.263","23.4"],
		['3',"SIPL_PRIDE_2020_0006","2020-10-28T20:17:43.763","2020-10-28T21:02:36.493","22.9"],
		['3',"SIPL_PRIDE_2020_0006","2020-10-28T17:03:03.247","2020-10-28T17:35:45.673","27.3"],
	];
	return (
		<>
		  <div style={{ marginTop: "10px" }}>
			
			<MUIDataTable
			  title={"Delivered KL"}
			  data={dataArr1}
			  columns={columns}
			  options={options} />

		  </div>
		</>
	);

  }
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    userRole: state.auth.user[0].userType,
    userId: state.auth.user[0].id
  }
}

export default connect(
  mapStateToProps,
  null
)(DemoTankFlowView)
